export default __webpack_public_path__ + "static/media/movies.4ebea6d2.jpg";